import ACTION, { AUXDASHBOARD_DATA_STATE, AP_PASS_INFO_DATA_STATE } from './creator'

const init = {
  status: AUXDASHBOARD_DATA_STATE.PENDING,
  message: '',
  tableList: [],
}
const pass_info_data_init = {
  status: AP_PASS_INFO_DATA_STATE.PENDING,
  message: '',
  data: {
    bodyPass: {
      approved: 0,
      pending: 0,
      rejected: 0,
    },
    vehiclePass: {
      approved: 0,
      pending: 0,
      rejected: 0,
    },
    safetyBriefing: {
      paid: 0,
      pending: 0,
    },
  },
}

export const auxDashboardDataList = (state = init, { type, payload }) => {
  switch (type) {
    case ACTION.AUXDASHBOARD_DATA.PENDING:
    case ACTION.AUXDASHBOARD_DATA.SUCCESS:
    case ACTION.AUXDASHBOARD_DATA.FAILURE:
      return { ...state, ...payload }
    case ACTION.AUXDASHBOARD_DATA.UPDATE_LIST:
      // payload = {id: , status: Approved|Rejected}
      if (!payload.id) {
        return
      }
      const findIndex = state.tableList.findIndex((item) => {
        return item.id === payload.id
      })
      if (findIndex !== -1) {
        state.tableList[findIndex].statusApplication = payload.statusApplication
        state.tableList[findIndex].statusPayment = payload.statusPayment
        state.tableList[findIndex].statusCollection = payload.statusCollection
      }

      return { ...state }
    default:
      return state
  }
}

export const apPassInfoData = (state = pass_info_data_init, { type, payload }) => {
  switch (type) {
    case ACTION.PASS_INFO.PENDING:
    case ACTION.PASS_INFO.SUCCESS:
    case ACTION.PASS_INFO.FAILURE:
      return { ...state, ...payload }
    default:
      return state
  }
}
